import { IObj } from 'shared/types/common'
import { getPresById } from './axios/axiosQueries/presentation.requests'

const getParams = (search: string): IObj<string> =>
  search
    .replace('?', '')
    .split('&')
    .reduce((p: IObj<string>, e) => {
      const a = e.split('=')
      p[decodeURIComponent(a[0])] = decodeURIComponent(a[1])
      return p
    }, {})

const getHashFromUrl = (url: string): string =>
  url.includes('#') ? url.substring(url.indexOf('#')) : ''

const concatParams = (query: IObj<string | string[] | number | Date | undefined>): string => {
  const keys = Object.keys(query)
  return keys.reduce((acc, key) => {
    const ampersand = acc ? `&${acc}` : ''
    if (!query[key]) return acc
    return `${key}=${query[key]}${ampersand}`
  }, '')
}

const getPresByUrl = async () => {
  const presId = window.location.href.split('/').at(-1)
  if (!presId) throw new Error('Wrong presentation id')
  const result = await getPresById(presId)
  if (!result._id) throw new Error(`There is no pres with id ${presId}`)
  return result
}

export { concatParams, getHashFromUrl, getParams, getPresByUrl }
